import React, { useContext, useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";

import {
  Grid,
  Paper,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CardActions,
  FormControlLabel,
  Checkbox,
  Tabs,
  Tab,
  Box,
} from "@material-ui/core";

import { KeyboardDatePicker } from "@material-ui/pickers";
import QualificationTable from "./QualificationsTable";
import MembershipTable from "./MembershipTable";
import LanguagesTable from "./LanguagesTable";
import ReferenceDetails from "./ReferenceDetails";
import { Notes } from "./Notes";
import { AuthContext } from "../../../../../context/states/authState";

const TabPanel = ({ children, value, tabKey }) => {
  return value === tabKey ? <Box mt={2}>{children}</Box> : null;
};

const tabs = [
  { label: "Details", permission: "edit-recruitment.details" },
  {
    label: "References",
    permission: "edit-recruitment.references",
  },
  {
    label: "Notes",
    permission: "edit-recruitment.notes",
  },
];

const EditRecruitmentForm = ({
  recruitment,
  handleUpdate,
  handleBack,
  classes,
  isAccessTo,
  username,
  role,
  updateRecruitmentNotesHandler,
}) => {
  const [tab, setTab] = useState(null);
  const [fieldValues, setFieldValues] = useState({
    name: recruitment?.name || "",
    contactNumber: recruitment?.contactNumber || "",
    email: recruitment?.email || "",
    address: recruitment?.address || "",
    origin: recruitment?.origin || "",
    passport: recruitment?.passport || "",
    nationality: recruitment?.nationality || "",
    statusInUk: recruitment?.statusInUk || "",
    experience: recruitment?.experience || "",
    approximateHours: recruitment?.approximateHours || "",
    carriedOut: recruitment?.carriedOut || "",
  });
  const defaultValues = {
    _id: "",
    name: "",
    dob: "",
    gender: "",
    contactNumber: "",
    email: "",
    address: "",
    origin: "",
    passport: "",
    nationality: "",
    statusInUk: "",
    experience: "",
    approximateHours: "",
    carriedOut: "",
    memberTextOne: "",
    memberTextTwo: "",
    memberTextThree: "",
    otherTextOne: "",
    otherTextTwo: "",
    recId: "",

    doYouHaveCrbDbsCtc: false,
    doYouDrive: false,
    assignments: false,
    willingToTravel: false,
    basiceInterpreting: false,
    levelTwo: false,
    levelThree: false,
    levelSix: false,
    dpiFormerly: false,
    dpsiHealth: false,
    dpsiLaw: false,
    dpsiLocalGovt: false,
    indHomeOffice: false,
    ukBorderAgency: false,
    languageRelatedDegree: false,
    nrpsi: false,
    otherOne: false,
    otherTwo: false,

    services: [
      {
        id: 1,
        language: "",
        dialect: "",
        telephone: false,
        video: false,
        onsite: false,
        translation: false,
        transcription: false,
      },
    ],
    referenceResponses: recruitment.referenceResponses?.length
      ? recruitment.referenceResponses
      : [
          {
            _id: "",
            refName: "",
            refPosition: "",
            refDepartment: "",
            refCompany: "",
            refEmail: "",
            refContactNumber: "",
          },
          {
            _id: "",
            refName: "",
            refPosition: "",
            refDepartment: "",
            refCompany: "",
            refEmail: "",
            refContactNumber: "",
          },
          {
            _id: "",
            refName: "",
            refPosition: "",
            refDepartment: "",
            refCompany: "",
            refEmail: "",
            refContactNumber: "",
          },
        ],
  };

  const handleTabChange = (e, newValue) => {
    setTab(newValue);
  };

  const handleMaxLengthFieldChange = (field, value) => {
    setFieldValues((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const { permissionKeys } = useContext(AuthContext);

  const canView = (key) => permissionKeys.includes(key);
  const tabChangeHandler = (event, newValue) => setTab(newValue);

  const {
    register,
    handleSubmit,
    control,
    reset,
    watch,
    formState: { isDirty, isValid, errors },
  } = useForm({
    mode: "onChange",
    defaultValues,
  });

  const maxLengths = {
    name: 100,
    gender: 25,
    contactNumber: 50,
    email: 75,
    address: 200,
    origin: 50,
    passport: 200,
    nationality: 200,
    statusInUk: 200,
    experience: 750,
    approximateHours: 750,
    carriedOut: 750,
  };

  const maxLengthErrors = {
    name:
      fieldValues.name.length > maxLengths.name
        ? `Name cannot exceed ${maxLengths.name} characters`
        : "",

    contactNumber:
      fieldValues.contactNumber.length > maxLengths.contactNumber
        ? `Contact Number cannot exceed ${maxLengths.contactNumber} characters`
        : "",

    email:
      fieldValues.email.length > maxLengths.email
        ? `Email cannot exceed ${maxLengths.email} characters`
        : "",

    address:
      fieldValues.address.length > maxLengths.address
        ? `Address cannot exceed ${maxLengths.address} characters`
        : "",

    origin:
      fieldValues.origin.length > maxLengths.origin
        ? `Country of Origin cannot exceed ${maxLengths.origin} characters`
        : "",

    passport:
      fieldValues.passport.length > maxLengths.passport
        ? `Passport cannot exceed ${maxLengths.passport} characters`
        : "",

    nationality:
      fieldValues.nationality.length > maxLengths.nationality
        ? `Nationality cannot exceed ${maxLengths.nationality} characters`
        : "",

    statusInUk:
      fieldValues.statusInUk.length > maxLengths.statusInUk
        ? `Status in UK cannot exceed ${maxLengths.statusInUk} characters`
        : "",

    experience:
      fieldValues.experience.length > maxLengths.experience
        ? `Experience cannot exceed ${maxLengths.experience} characters`
        : "",

    approximateHours:
      fieldValues.approximateHours.length > maxLengths.approximateHours
        ? `Approximate Hours cannot exceed ${maxLengths.approximateHours} characters`
        : "",

    carriedOut:
      fieldValues.carriedOut.length > maxLengths.carriedOut
        ? `Translation work details cannot exceed ${maxLengths.carriedOut} characters`
        : "",
  };

  const hasMaxLengthErrors = Object.values(maxLengthErrors).some(Boolean);

  useEffect(() => {
    if (recruitment) {
      const refs = recruitment.referenceResponses || [];

      // ✅ clone existing refs
      const filledRefs = [...refs];

      // ✅ ensure always 3
      while (filledRefs.length < 3) {
        filledRefs.push({
          _id: "",
          refName: "",
          refPosition: "",
          refDepartment: "",
          refCompany: "",
          refEmail: "",
          refContactNumber: "",
        });
      }

      const data = {
        ...defaultValues,
        ...recruitment,
        dob: recruitment?.dob ? new Date(recruitment.dob) : null,
        services: recruitment?.services?.length
          ? recruitment.services
          : defaultValues.services,
        referenceResponses: filledRefs, // ✅ ALWAYS 3
      };

      reset(data);

      setFieldValues({
        name: data.name || "",
        contactNumber: data.contactNumber || "",
        email: data.email || "",
        address: data.address || "",
        origin: data.origin || "",
        passport: data.passport || "",
        nationality: data.nationality || "",
        statusInUk: data.statusInUk || "",
        experience: data.experience || "",
        approximateHours: data.approximateHours || "",
        carriedOut: data.carriedOut || "",
      });
    }
  }, [recruitment, reset]);

  const availableTabs = tabs.filter((tab) =>
    permissionKeys.includes(tab.permission),
  );

  useEffect(() => {
    if (
      availableTabs.length &&
      !availableTabs.some((t) => t.permission === tab)
    ) {
      setTab(availableTabs[0].permission);
    }
  }, [availableTabs, tab]);

  const onSubmit = async (data) => {
    if (hasMaxLengthErrors) {
      return;
    }

    await handleUpdate({
      ...data,
      _id: recruitment._id,
    });
  };

  const checkboxFields = [
    "doYouHaveCrbDbsCtc",
    "doYouDrive",
    "assignments",
    "willingToTravel",
    "basiceInterpreting",
    "levelTwo",
    "levelThree",
    "levelSix",
    "dpiFormerly",
    "dpsiHealth",
    "dpsiLaw",
    "dpsiLocalGovt",
    "indHomeOffice",
    "ukBorderAgency",
    "languageRelatedDegree",
    "nrpsi",
    "otherOne",
    "otherTwo",
  ];

  console.log("FORM ERRORS:", errors);
  console.log("FORM VALID:", isValid);

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Tabs value={tab} onChange={handleTabChange} indicatorColor="primary">
        {availableTabs.map((item) => (
          <Tab
            key={item.permission}
            label={item.label}
            value={item.permission}
          />
        ))}
      </Tabs>

      {/* TAB 1 - DETAILS */}
      <TabPanel value={tab} tabKey="edit-recruitment.details">
        <Paper className={classes.paper} variant="outlined">
          <Grid container spacing={2}>
            <input name="_id" ref={register} type="hidden" />

            <Grid item xs={12} md={6}>
              <TextField
                label="Name"
                fullWidth
                size="small"
                variant="outlined"
                name="name"
                inputRef={register}
                InputLabelProps={{ shrink: true }}
                error={Boolean(maxLengthErrors.name)}
                helperText={maxLengthErrors.name}
                onChange={(e) =>
                  handleMaxLengthFieldChange("name", e.target.value)
                }
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <Controller
                as={
                  <KeyboardDatePicker
                    autoOk
                    format="dd/MM/yyyy"
                    label="Date of Birth"
                    size="small"
                    variant="inline"
                    fullWidth
                    inputVariant="outlined"
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                  />
                }
                control={control}
                name="dob"
                rules={{ required: true }}
                error={false}
                defaultValue={null}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <FormControl fullWidth size="small" variant="outlined">
                <InputLabel>Gender</InputLabel>
                <Controller
                  as={
                    <Select label="Gender">
                      <MenuItem value="">None</MenuItem>
                      <MenuItem value="male">Male</MenuItem>
                      <MenuItem value="female">Female</MenuItem>
                    </Select>
                  }
                  name="gender"
                  control={control}
                  defaultValue=""
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                label="Contact Number"
                fullWidth
                size="small"
                variant="outlined"
                name="contactNumber"
                inputRef={register}
                InputLabelProps={{ shrink: true }}
                error={Boolean(maxLengthErrors.contactNumber)}
                helperText={maxLengthErrors.contactNumber}
                onChange={(e) =>
                  handleMaxLengthFieldChange("contactNumber", e.target.value)
                }
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                label="Email"
                fullWidth
                size="small"
                variant="outlined"
                name="email"
                inputRef={register}
                InputLabelProps={{ shrink: true }}
                error={Boolean(maxLengthErrors.email)}
                helperText={maxLengthErrors.email}
                onChange={(e) =>
                  handleMaxLengthFieldChange("email", e.target.value)
                }
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <FormControl fullWidth size="small" variant="outlined">
                <InputLabel>Status</InputLabel>
                <Controller
                  as={
                    <Select label="Status">
                      <MenuItem value="New">New</MenuItem>
                      <MenuItem value="Upcoming Interviews">
                        Upcoming Interviews
                      </MenuItem>
                      <MenuItem value="Interviewed">Interviewed</MenuItem>
                      <MenuItem value="Reg Docs Sent">Reg Docs Sent</MenuItem>
                      <MenuItem value="Reg Docs Received">
                        Reg Docs Received
                      </MenuItem>
                      <MenuItem value="Profile Created">
                        Profile Created
                      </MenuItem>
                      <MenuItem value="References Requested">
                        References Requested
                      </MenuItem>
                      <MenuItem value="References Received">
                        References Received
                      </MenuItem>
                      <MenuItem value="Declined By LIL">
                        Declined By LIL
                      </MenuItem>
                      <MenuItem value="Declined By IP">Declined By IP</MenuItem>
                      <MenuItem value="Docs Uploaded / Awaiting Activation">
                        Docs Uploaded / Awaiting Activation
                      </MenuItem>
                      <MenuItem value="Activated">Activated</MenuItem>
                      <MenuItem value="Deactivated">Deactivated</MenuItem>
                      <MenuItem value="Duplicate">Duplicate</MenuItem>
                    </Select>
                  }
                  name="status"
                  control={control}
                  defaultValue="New"
                />
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              <TextField
                label="Address"
                multiline
                rows={2}
                fullWidth
                size="small"
                variant="outlined"
                name="address"
                inputRef={register}
                InputLabelProps={{ shrink: true }}
                error={Boolean(maxLengthErrors.address)}
                helperText={maxLengthErrors.address}
                onChange={(e) =>
                  handleMaxLengthFieldChange("address", e.target.value)
                }
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                label="Country of Origin"
                fullWidth
                size="small"
                variant="outlined"
                name="origin"
                inputRef={register}
                InputLabelProps={{ shrink: true }}
                error={Boolean(maxLengthErrors.origin)}
                helperText={maxLengthErrors.origin}
                onChange={(e) =>
                  handleMaxLengthFieldChange("origin", e.target.value)
                }
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                label="Passport"
                fullWidth
                size="small"
                variant="outlined"
                name="passport"
                inputRef={register}
                InputLabelProps={{ shrink: true }}
                error={Boolean(maxLengthErrors.passport)}
                helperText={maxLengthErrors.passport}
                onChange={(e) =>
                  handleMaxLengthFieldChange("passport", e.target.value)
                }
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                label="Nationality"
                fullWidth
                size="small"
                variant="outlined"
                name="nationality"
                inputRef={register}
                InputLabelProps={{ shrink: true }}
                error={Boolean(maxLengthErrors.nationality)}
                helperText={maxLengthErrors.nationality}
                onChange={(e) =>
                  handleMaxLengthFieldChange("nationality", e.target.value)
                }
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                label="Status in UK"
                fullWidth
                size="small"
                variant="outlined"
                name="statusInUk"
                inputRef={register}
                InputLabelProps={{ shrink: true }}
                error={Boolean(maxLengthErrors.statusInUk)}
                helperText={maxLengthErrors.statusInUk}
                onChange={(e) =>
                  handleMaxLengthFieldChange("statusInUk", e.target.value)
                }
              />
            </Grid>

            <Grid item xs={12} md={12} key={"doYouHaveCrbDbsCtc"}>
              <Controller
                name="doYouHaveCrbDbsCtc"
                control={control}
                defaultValue={false}
                render={({ value, onChange }) => (
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={!!value}
                        onChange={(e) => onChange(e.target.checked)}
                      />
                    }
                    label={"Do you have CRB/DBS/CTC?"}
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} md={12} key={"doYouDrive"}>
              <Controller
                name="doYouDrive"
                control={control}
                defaultValue={false}
                render={({ value, onChange }) => (
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={!!value}
                        onChange={(e) => onChange(e.target.checked)}
                      />
                    }
                    label={"Do you drive?"}
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} md={12} key={"assignments"}>
              <Controller
                name="assignments"
                control={control}
                defaultValue={false}
                render={({ value, onChange }) => (
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={!!value}
                        onChange={(e) => onChange(e.target.checked)}
                      />
                    }
                    label={"Are you available for short notice assignments?"}
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} md={12} key={"willingToTravel"}>
              <Controller
                name="willingToTravel"
                control={control}
                defaultValue={false}
                render={({ value, onChange }) => (
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={!!value}
                        onChange={(e) => onChange(e.target.checked)}
                      />
                    }
                    label={
                      "Are you willing to travel: (In & Out of London / within UK)?"
                    }
                  />
                )}
              />
            </Grid>

            {/* Languages Table */}

            <LanguagesTable
              control={control}
              services={recruitment?.services}
            />

            <Grid style={{ paddingBlock: 20 }} item xs={12} md={12}>
              <TextField
                label="What is your experience in legal / medical / private / health interpreting?"
                fullWidth
                multiline
                rows={3}
                size="small"
                variant="outlined"
                name="experience"
                inputRef={register}
                InputLabelProps={{ shrink: true }}
                error={Boolean(maxLengthErrors.experience)}
                helperText={maxLengthErrors.experience}
                onChange={(e) =>
                  handleMaxLengthFieldChange("experience", e.target.value)
                }
              />
            </Grid>

            <Grid style={{ paddingBlock: 20 }} item xs={12} md={12}>
              <TextField
                label="Approximate hours of legal / private interpreting in the last 2-3 years or in total?"
                fullWidth
                multiline
                rows={3}
                size="small"
                variant="outlined"
                name="approximateHours"
                inputRef={register}
                InputLabelProps={{ shrink: true }}
                error={Boolean(maxLengthErrors.approximateHours)}
                helperText={maxLengthErrors.approximateHours}
                onChange={(e) =>
                  handleMaxLengthFieldChange("approximateHours", e.target.value)
                }
              />
            </Grid>

            <Grid style={{ paddingBlock: 20 }} item xs={12} md={12}>
              <TextField
                label="Have you carried out any translation work? If so, please list out the documents you have translated? (example: certificates, statements etc)"
                fullWidth
                multiline
                rows={3}
                size="small"
                variant="outlined"
                name="carriedOut"
                inputRef={register}
                InputLabelProps={{ shrink: true }}
                error={Boolean(maxLengthErrors.carriedOut)}
                helperText={maxLengthErrors.carriedOut}
                onChange={(e) =>
                  handleMaxLengthFieldChange("carriedOut", e.target.value)
                }
              />
            </Grid>

            <QualificationTable control={control} />

            <MembershipTable control={control} />
          </Grid>
        </Paper>
      </TabPanel>

      <TabPanel value={tab} tabKey="edit-recruitment.references">
        <ReferenceDetails
          control={control}
          recName={recruitment.name}
          recId={recruitment.recId}
          username={username}
        />
      </TabPanel>

      {/* TAB 3 - NOTES */}
      <TabPanel value={tab} tabKey="edit-recruitment.notes">
        <Notes
          data={recruitment}
          handleUpdate={updateRecruitmentNotesHandler}
          handleClose={handleBack}
          isAccessTo={isAccessTo}
          role={role}
          username={username}
          classes={classes}
          recId={recruitment.recId}
        />
      </TabPanel>

      {/* ACTIONS */}
      <CardActions style={{ justifyContent: "flex-end" }}>
        <Button onClick={handleBack}>Back</Button>

        <Button
          type="submit"
          color="primary"
          variant="contained"
          disabled={!isDirty || !isValid || hasMaxLengthErrors}
        >
          Update
        </Button>
      </CardActions>
    </form>
  );
};

export default EditRecruitmentForm;
